import React from "react";
import "../../Components/Menu/Menu.css";

export default function Disclosure() {
  return (
    <div>
      <h4 className="sub-title">Utlevering av personopplysninger </h4>
      <p className="content">
        Informasjon som kan knyttes til deg som person vil ikke bli delt med
        andre, med mindre vi er pålagt i lov å gjøre det eller at du spesifikt
        har samtykket til det.<br></br>
        GMG kan dele personopplysningene dine med tjenestetilbydere i appen i
        tilfeller hvor du har bestilt tjenester hos en underleverandør og
        personopplysningene er nødvendige for å gjennomføre tjenesten. GMG er
        ikke behandlingsansvarlig for personopplysninger som behandles hos
        tjenestetilbydere i appen.
      </p>
    </div>
  );
}
